import PropTypes from 'prop-types';
import React from 'react';
import { Icon, Menu as BaseMenu, Typography } from 'antd';
import { withTranslation } from 'react-i18next';

import Link from '../link';
import { BalanceDisplayer } from '../balance-displayer/BalanceDisplayer';

import './header.scss';

const { Title } = Typography;

const AccountDetails = ({ account, t }) => {
  if (!account) { return (<></>); }
  return (
    <div className="block-account">
      <Title level={3} className="mb0">
        <Link
          to={`/accounts/${account.id}`}
          className="alias-link"
        >
          {account.alias}
        </Link>
      </Title>
      <BalanceDisplayer account={account} className="header-balance-block" showUpdatedAt />
      <BaseMenu
        mode="horizontal"
        theme="light"
        className="menu"
        selectable={false}
      >
        <BaseMenu.Item key="transactions">
          <Link to={`/accounts/${account.id}/transactions`}>
            <Icon type="unordered-list" /> {t('transactions')}
          </Link>
        </BaseMenu.Item>
        <BaseMenu.Item key="batches">
          <Link to={`/accounts/${account.id}/batches`}>
            <Icon type="upload" /> {t('batches')}
          </Link>
        </BaseMenu.Item>
      </BaseMenu>
    </div>
  );
};

AccountDetails.propTypes = {
  account: PropTypes.shape({
    alias: PropTypes.string,
    id: PropTypes.string,
  }),
  t: PropTypes.func,
};

const TranslatedAccountDetails = withTranslation()(AccountDetails);
export { TranslatedAccountDetails as AccountDetails };
